import { useAccountStore } from '@/stores/account.js';
import { defineChannelAccountStore } from '@/stores/channelAccount.js';

// The Walmart account the /walmart/* analytics pages read. Rows come from the integration
// service's connections list (id, display name, market, status, partner status); the id
// travels to olap as the Walmartaccountid header — the seller id never does.
//
// Only ACTIVE accounts are offered. olap reads an account only while it is ACTIVE (a
// DISCONNECTED or REVOKED one is a 403), and a connection that is not ACTIVE has no access to
// channel data. With none, the pages show the empty state that points at Settings.
export const isReadableWalmartAccount = (account) => account?.status === 'ACTIVE';

export const fetchReadableWalmartAccounts = async () =>
  ((await useAccountStore().fetchWalmartConnections()) || []).filter(isReadableWalmartAccount);

export const useWalmartAccountStore = defineChannelAccountStore('walmartAccount', {
  storagePrefix: 'wp.walmart.selectedAccount',
  fetchAccounts: fetchReadableWalmartAccounts,
});

// An account's display name: the seller's own name, else the market, else the account id.
export const walmartAccountLabel = (account) => {
  const name = account?.displayName || (account?.id != null ? `#${account.id}` : '');
  return account?.market && name ? `${name} · ${account.market}` : name;
};
